import { CmsApiEmailCampaignSignupDoubleBlockData } from 'modules/cms/api/types/CmsApiEmailCampaignSignupDouble';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpEmailCampaignSignupDoubleBlock({
  content,
  blockId,
  data,
}: CmsAmpBlockMappingComponentProps<CmsApiEmailCampaignSignupDoubleBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        image: data.bgImage,
        text: data.headline,
        buttonText: data.buttonTextOne,
        isEmailSignup: true,
      }}
    />
  );
}
